var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilesFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profiles_Fill",
    "data-name": "Profiles Fill",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profiles_Fill-2",
    "data-name": "Profiles Fill",
    transform: "translate(30.114 231.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(56.924 -0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.962,
    cy: 3.962,
    r: 3.962,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(53.895 8.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M60.886,256a6.991,6.991,0,0,0-6.991,6.991,1.864,1.864,0,0,0,1.864,1.864H66.013a1.864,1.864,0,0,0,1.864-1.864A6.991,6.991,0,0,0,60.886,256Z",
    transform: "translate(-53.895 -256)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesFill);
export default __webpack_public_path__ + "static/media/profilesFill.969179d01302e6be77ef59eb9f94cf55.svg";
export { ForwardRef as ReactComponent };